import { render, staticRenderFns } from "./userViewUserInfoCard.vue?vue&type=template&id=5fe2269b&"
import script from "./userViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./userViewUserInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports